/**
 * Проверка на нов вътрешен номер, преди да влезе в таблицата.
 *
 * Сървърът приема списъка като upsert по номера: дубликат не би бил отказан, а
 * би преименувал мълчаливо служителя, който вече стои на този номер. Затова
 * проверката за съществуващ номер е тук, а не само за удобство.
 */

export interface ExtensionDraft {
  extension: string;
  employeeName: string;
}

/** Същият шаблон като в шаблона за имена на файлове и в схемата на сървъра. */
const EXTENSION_PATTERN = /^\d{2,4}$/;

/** Връща съобщението за проблем, или `null`, ако редът може да се добави. */
export function validateExtensionDraft(
  draft: ExtensionDraft,
  existing: readonly string[],
): string | null {
  const extension = draft.extension.trim();

  if (!EXTENSION_PATTERN.test(extension)) return 'Вътрешният номер е 2–4 цифри';
  if (draft.employeeName.trim().length < 2) return 'Името на служителя е задължително';
  if (existing.includes(extension)) return `Вътрешен номер ${extension} вече е в списъка`;

  return null;
}
